module.exports = __webpack_public_path__ + "static/media/telegram-solid.1a60e09d.svg";